import React from 'react';
import { Package, CheckCircle2, AlertTriangle } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { Helmet } from 'react-helmet-async';

const PackagingGuidePage = () => {
  return (
    <>
      <Helmet>
        <title>International Shipping Packaging Guide | Best Practices – Shippzy</title>
        <meta name="description" content="Complete packaging guide for international shipping. Learn proper packing techniques, materials, and best practices for safe delivery from Canada worldwide." />
        <link rel="canonical" href="https://www.shippzy.ca/packaging-guide-international-shipping" />
      </Helmet>
      <div className="min-h-screen bg-white">
        <section className="bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl">
              <h1 className="text-5xl md:text-6xl font-bold mb-6">International Shipping Packaging Guide</h1>
              <p className="text-xl text-gray-300 mb-8">Proper packaging ensures your items arrive safely. Learn best practices for international shipping from Canada.</p>
            </div>
          </div>
        </section>
        <section className="py-20 bg-gray-50">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Packaging Best Practices</h2>
            <div className="space-y-6">
              <Card><CardContent className="pt-6"><div className="flex gap-3"><CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" /><div><h3 className="font-semibold text-gray-900 mb-2">Use Sturdy Boxes</h3><p className="text-gray-600">Choose strong cardboard boxes appropriate for the weight of your items. Double-wall boxes for heavier shipments.</p></div></div></CardContent></Card>
              <Card><CardContent className="pt-6"><div className="flex gap-3"><CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" /><div><h3 className="font-semibold text-gray-900 mb-2">Protect Fragile Items</h3><p className="text-gray-600">Use bubble wrap, foam, or packing peanuts for cushioning. Wrap each fragile item individually.</p></div></div></CardContent></Card>
              <Card><CardContent className="pt-6"><div className="flex gap-3"><CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" /><div><h3 className="font-semibold text-gray-900 mb-2">Seal Properly</h3><p className="text-gray-600">Use quality packing tape to seal all seams. Reinforce bottom and top of box.</p></div></div></CardContent></Card>
              <Card><CardContent className="pt-6"><div className="flex gap-3"><CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" /><div><h3 className="font-semibold text-gray-900 mb-2">Label Clearly</h3><p className="text-gray-600">Ensure shipping labels are clearly visible and securely attached. Remove old labels.</p></div></div></CardContent></Card>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default PackagingGuidePage;